import React, {useMemo, useContext, useEffect, useCallback, useState} from 'react';
import { Grid,Form, TextArea ,Icon, Checkbox, Popup} from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';
import { ReconGlobalContext } from '../../providers/ReconGlobalProvider';
import HeaderTabForm1 from './HeaderTabForm1';
import HeaderTabForm2 from './HeaderTabForm2';
import HeaderTabForm3 from './HeaderTabForm3';
import HeadertabForm4 from './HeaderTabForm4';
import { getBrokerUiEnvironment } from '../../../../util/index';

const HeaderTab = ({onChange, onSelect, onBlur, paymentOnSelect}) => {
  const { headerTabData} = useSelector((state) => state.header);
  const{
  orgRevenueDetails={},
  reconRevenueDetails={},
  } = headerTabData;

  const lowerEnv = [getBrokerUiEnvironment()];//seems wrong, change when possible

  const {kxUser: {channelConnections: {customersConnected:importerList=[]}={}}} = useContext(ReconGlobalContext);
  
  return (
    <div className='recon-header2'>
      <Grid className="responsiveGridCss1 headerTabFromSection1" data-reducer="updateHeaderTab"> 
        <HeaderTabForm1 formData={headerTabData} lowerEnv={lowerEnv} onChange={onChange} onBlur={onBlur} onSelect={onSelect} />
        <HeaderTabForm2 formData={headerTabData} lowerEnv={lowerEnv} onChange={onChange} onBlur={onBlur} onSelect={onSelect} paymentOnSelect={paymentOnSelect} importerList={importerList} />
      </Grid>
      <div className='headerTabFromSection2'>
        {Object.keys(orgRevenueDetails).length > 0 && <div className="headerTabFromSection2Column1">
          <HeaderTabForm3 formData={{orgRevenueDetails, reconRevenueDetails}} onChange={onChange} onBlur={onBlur}/>
        </div>}
        <div className="headerTabFromSection2Column2">
          <HeadertabForm4 formData={headerTabData} onChange={onChange} onBlur={onBlur}/> 
        </div>
      </div>
    </div>
  );
};

export default HeaderTab;